import BaseAPI from "../api";
const path: string = "complaints-type";


export type complaintType = {
    keyword?: string;
    status?: string;
    limit?: number;
    page?: number;
}
export enum COMPLAINT_TYPE_STATUS {
    ACTIVE = "active",
    INACTIVE = "inactive",
    DELETE = 'delete'
}
export type updateStatusType = {
    status: string;
}
export type complaintTypeBody = {
    complaints_type_name: string;
}
export class ComplaintTypeApi extends BaseAPI {
    static getList(query: complaintType): Promise<any> {
        return this.api.get(`${path}`, {
            params: { ...query }
        })
    }
    static updateStatus(id_complaints_type: number, body: updateStatusType): Promise<any> {
        return this.api.patch(`${path}/${id_complaints_type}/status`, body)
    }
    static createComplaintType(body: complaintTypeBody): Promise<any> {
        return this.api.post(`${path}`, body)
    }
    static findOne(id_complaints_type: number): Promise<any> {
        return this.api.get(`${path}/${id_complaints_type}`)
    }
    static updateOne(id_complaints_type: number, body: complaintTypeBody): Promise<any> {
        return this.api.patch(`${path}/${id_complaints_type}`, body)
    }
}